// src/views/components/Button/Button.jsx
import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import Magnetic from '../Motion/Magnetic';
import '../components.css';

const Button = ({
  children,
  variant = 'primary',
  className = '',
  icon: Icon,
  onClick,
  type = 'button',
  fullWidth,
  style,
  magnetic = false,
  disabled = false,
}) => {
  const shouldReduceMotion = useReducedMotion();
  const [ripples, setRipples] = useState([]);

  const handlePointerDown = (e) => {
    if (disabled || shouldReduceMotion) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const id = Date.now();

    setRipples((prev) => [...prev, { x, y, id }]);

    setTimeout(() => {
      setRipples((prev) => prev.filter((r) => r.id !== id));
    }, 600);
  };

  const btnContent = (
    <motion.button
      type={type}
      disabled={disabled}
      className={`btn btn-${variant} ${className}`}
      style={{
        position: 'relative',
        overflow: 'hidden',
        ...(fullWidth ? { width: '100%' } : {}),
        ...style,
      }}
      onClick={onClick}
      onPointerDown={handlePointerDown}
      whileHover={shouldReduceMotion ? {} : { scale: 1.02, y: -2 }}
      whileTap={shouldReduceMotion ? {} : { scale: 0.96 }}
      transition={{ type: 'spring', stiffness: 450, damping: 20 }}
    >
      {/* Shine Sweep Overlay */}
      <span className="btn-shine-overlay" />

      {/* Ripple elements */}
      {ripples.map((r) => (
        <span
          key={r.id}
          className="btn-ripple"
          style={{
            left: r.x,
            top: r.y,
          }}
        />
      ))}

      {Icon && (
        <motion.span
          style={{ display: 'inline-flex', alignItems: 'center' }}
          whileHover={{ rotate: 8 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          <Icon size={18} />
        </motion.span>
      )}
      <span style={{ position: 'relative', zIndex: 2 }}>{children}</span>
    </motion.button>
  );

  if (magnetic && !disabled) {
    return <Magnetic strength={0.25}>{btnContent}</Magnetic>;
  }

  return btnContent;
};

export default Button;
